var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inputFieldVue',{attrs:{"inputData":_vm.inputData},on:{"triggermachine":function($event){return _vm.triggermachine($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }